import {combine} from 'effector';

import {clearDocumentsGridCache} from 'api';
import {fetchMovingGrid} from 'api/documents/documents';
import {createGridTableModel} from 'core/hooks/grid2.0';
import {rootDomain} from 'core/rootDomain';
import {MovingGridRawRow} from 'types';
import {SimplePaginationContent} from 'types/api';

const domain = rootDomain.createDomain('DocumentsGridTableDomain');

export const fetchDataFx = domain.createEffect({
    name: 'fetchDocumentListFx',
    handler: fetchMovingGrid,
});

export const clearDataCacheFx = domain.createEffect({
    name: 'clearDataCacheFx',
    handler: clearDocumentsGridCache,
});

export const {
    filters$,
    filtersChanged,
    filtersReset,
    defaultFilters,
    sortings$,
    sortingsChanged,
    sortingsReset,
    defaultSortings,
    pageNumber$,
    pageNumberChanged,
    pageSize$,
    pageSizeChanged,
    Gate,
    tableStateChanged,
    tableStateCacheChanged,
    stateReset,
} = createGridTableModel({
    domain,
});

export const data$ = domain.createStore<SimplePaginationContent<MovingGridRawRow> | null>(null);

export const searchChanged = domain.createEvent<string>();
export const searchReset = domain.createEvent();
export const search$ = domain
    .createStore<string>('')
    .on(searchChanged, (_, value) => value)
    .reset(searchReset);

export const refetchWithSortByDescDate = domain.createEvent();

export const gridCacheChanged = domain.createEvent<{pageNumber: number; token: string | null}>();
export const gridCacheReset = domain.createEvent();
export const gridTokensCache$ = domain.createStore<Record<number, string | null>>({0: null});

export const tableState$ = combine({
    data: data$,
    pageNumber: pageNumber$,
    pageSize: pageSize$,
    filters: filters$,
    sortings: sortings$,
    search: search$,
    gridTokensCache: gridTokensCache$,
    isLoading: fetchDataFx.pending,
});
